import React from 'react';

// Push notification
import { initializePush } from 'helpers/push-notification';

const PushNotifications = () => {
	/* eslint-disable */
	React.useEffect(() => {
		initializePush();
	}, []);
	/* eslint-enable */

	return null;
};

export default PushNotifications;
